import { useAtomValue, useSetAtom } from "jotai";
import { useCallback, useMemo } from "react";

import {
	$acknowledgeRecentUpdates,
	$loadableUnacknowledgedRecentUpdates,
	type RecentUpdate,
} from "../../internal/recent-updates";

export const useRecentUpdates = (limit = 3) => {
	const updatesLoadable = useAtomValue($loadableUnacknowledgedRecentUpdates);
	const acknowledgeRecentUpdates = useSetAtom($acknowledgeRecentUpdates);

	const updates = useMemo(() => {
		if (updatesLoadable.state !== "hasData") {
			return [];
		}

		return updatesLoadable.data.slice(0, limit);
	}, [limit, updatesLoadable]);

	const acknowledge = useCallback(
		async (pendingUpdates?: RecentUpdate[]) => {
			await acknowledgeRecentUpdates(pendingUpdates ?? updates);
		},
		[acknowledgeRecentUpdates, updates]
	);

	return {
		isLoading: updatesLoadable.state === "loading",
		updates,
		acknowledge,
	};
};
